import { serverApi } from "./serverApi";
import { JsonType } from "../types/jsonValidationTypes";

export const jsonValidationService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllValidationType: build.query<Array<JsonType>, string>({
      query: () => ({
        url: "/validation/all-validation-types"
      })
    }),
  })
});

export const {
  useGetAllValidationTypeQuery
} = jsonValidationService;